<button (click)="click()" [class.active]="active" [disabled]="disabled" class="mainmenubutton tut_menu_button" mat-button>
  <svg-icon>menue</svg-icon>
  MENÜ
</button>
